import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { useRef } from "react";

interface FileUploadDialogueProps {
  setFile: (file: File | string) => void;
  setFileName: (fileName: string) => void;
  demoFile?: string;
  fileName: string;
  sheetImporting?: boolean;
}

const FileUploadDialogue : React.FC<FileUploadDialogueProps> = ({
  setFile,
  setFileName,
  demoFile,
  fileName,
  sheetImporting = false,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleInsertIconClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setFile(file);
      setFileName(file.name);
    }
    e.target.value = "";
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      {sheetImporting && (
        <span style={{ fontWeight: 600 }}>
          Download{" "}
          <a
            href={demoFile}
            style={{ color: "#38a5e5", cursor: "pointer" }}
            download
          >
            Demo{" "}
          </a>
          File.
        </span>
      )}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          height: "35px",
          marginTop: "5px",
        }}
      >
        <input
          type="file"
          style={{ display: "none" }}
          ref={fileInputRef}
          onChange={handleFileChange}
          accept={sheetImporting ? " " : "image/*"}
        />
        <input
          placeholder={sheetImporting ? "" : "Choose File"}
          style={{
            width: "85%",
            height: "100%",
            cursor: "default",
            pointerEvents: "none",
          }}
          className="form-control form-control-sm"
          value={fileName}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "15%",
            height: "100%",
            background: "#f4f5f8",
            border: "1px solid #ebedf2",
            color: "#575962",
            cursor: "pointer",
          }}
          onClick={handleInsertIconClick}
        >
          <InsertDriveFileIcon />
        </div>
      </div>
      {!sheetImporting && (
        <div className="mt-1" style={{ color: "red" }}>
          Accepted formats: JPG,JPEG,PNG,BMP,PDF
        </div>
      )}
    </div>
  );
};
export default FileUploadDialogue;
